"use client";
import { createContext, useEffect, useState, useCallback } from "react";
import ah from "@/lib/Axhelper";

// Create the Auth Context
export const AuthContext = createContext({
  user: null,
  loading: true,
  error: null,
  login: async () => {},
  logout: async () => {},
});

// Create the Auth Provider Component
export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUser = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await ah.sendGetAsync(`/api/uzytkownicy/me`);
      if (response.error) {
       throw new Error(response.error);
      }
      setUser(response.data);
    } catch (err) {
      // setError(err.message || 'An error occurred');
      console.error('AuthContext.fetchUser error:', err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      const response = await ah.sendGetAsync(`/api/uzytkownicy/logout`);
      if (response.error) {
        throw new Error(response.error);
      }
      setUser(null);
      localStorage.removeItem('token');
      return response;
    } catch (err) {
      setError(err.message || 'An error occurred');
      console.error('AuthContext.logout error:', err);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const response = await ah.sendPostAsync(`/api/uzytkownicy/authenticate`,{ email, password });
      if (response.error) {
        throw new Error(response.error);
      }
      // console.log('AuthContext.login response:', response);
      // let cookies = response.headers['set-cookie'];
      // console.log('AuthContext.login cookies:', cookies);
      setUser(response.data);
      // set local storage token to response.data.token
      localStorage.setItem('token', response.data.token);
      return response;
    } catch (err) {
      setError(err.message || 'An error occurred');
      return { error: err.message || 'An error occurred' };
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, []);

  const contextValue = {
    user,
    loading,
    error,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;